import { usePermissions } from '@/composables/usePermissions';
import type { NavItem, SharedData } from '@/types';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export function useNavPermissions() {
    const page = usePage<SharedData>();
    const { hasPermission, hasAnyPermission } = usePermissions();

    const user = computed(() => page.props.auth.user);

    const checkNavItemPermission = (item: NavItem): boolean => {
        const userData = user.value;

        if (item.customCheck === 'salary' && !userData.can_access_salary) {
            return false;
        }

        if (item.customCheck === 'isClient' && !userData.is_client) {
            return false;
        }

        if (item.customCheck === 'isNotClient' && userData.is_client) {
            return false;
        }

        if (item.customCheck === 'hasCorpayOne' && userData.is_client && !userData.has_corpay_one) {
            return false;
        }

        if (
            item.customCheck === 'hasOutlay' &&
            ((userData.is_client && !userData.has_outlay) || !userData.is_client)
        ) {
            return false;
        }

        if (!item.permissionLevel) {
            return true;
        }

        return Array.isArray(item.permissionLevel)
            ? hasAnyPermission(item.permissionLevel)
            : hasPermission(item.permissionLevel);
    };

    const filterNavItems = (items: NavItem[]): NavItem[] => {
        return items
            .map((item) => {
                const filteredItem = { ...item };
                if (item.subItems && item.subItems.length > 0) {
                    filteredItem.subItems = filterNavItems(item.subItems);
                }

                return filteredItem;
            })
            .filter((item) => {
                const hasMainPermission = checkNavItemPermission(item);
                if (item.subItems && item.subItems.length > 0) {
                    return hasMainPermission && item.subItems.length > 0;
                }

                return hasMainPermission;
            });
    };

    return {
        checkNavItemPermission,
        filterNavItems,
    };
}
